import styled from 'styled-components/macro';
import { TicketsFiltersLabelsText } from '../common/fontElements';

export const DropdownBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: ${(props) => (props.insideLabel ? 'center' : 'flex-end')};
  &.error.form-control {
    border: 1px solid #ce3b40;
  }
`;

export const DropdownText = styled(TicketsFiltersLabelsText)`
  font-family: 'Lato-Bold', sans-serif;
  display: block;
  margin-right: 7px;
  line-height: 25px;
`;

export const Dropdown = styled.div`
  display: block;
`;
